window.addEventListener('DOMContentLoaded', function(){
    console.log('Consolidated promo script loading...');
    
    // Show consolidated header if cookie is not set
    if(typeof getCookie !== 'undefined' && getCookie('consolidated_promo') != 'true'){
        const consolidatedHeader = document.querySelector('.tab-menu-promo-bar-header');
        if (consolidatedHeader) {
            if (typeof $ !== 'undefined') {
                $(consolidatedHeader).show();
            } else {
                consolidatedHeader.style.display = 'block';
            }
        }
    }
    
    // Handle close promo click
    const closeButtons = document.querySelectorAll('.close-promo');
    closeButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            const consolidatedHeader = document.querySelector('.tab-menu-promo-bar-header');
            if (consolidatedHeader) {
                if (typeof $ !== 'undefined') {
                    $(consolidatedHeader).slideUp();
                } else {
                    consolidatedHeader.style.display = 'none';
                }
            }
            
            if (typeof setCookie !== 'undefined') {
                setCookie('consolidated_promo', 'true', 1);
            }
        });
    });
    
    // Initialize Swiper if it exists and there are multiple blocks
    const promoSlider = document.querySelector('[id^="PromoSlider-"]');
    if (promoSlider && typeof Swiper !== 'undefined') {
        const slides = promoSlider.querySelectorAll('.swiper-slide');
        if (slides.length > 1) {
            // Get autoplay setting from data attribute
            const autoplayData = promoSlider.getAttribute('data-autoplay');
            const autoplayConfig = autoplayData && autoplayData !== 'false' ? JSON.parse(autoplayData) : false;
            
            new Swiper(promoSlider, {
                autoplay: autoplayConfig,
                loop: true,
                effect: 'fade'
            });
        }
    }
});